import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbDownOffAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_down_off_alt"}/>
}
